export const PLAYER_EVENT = {
    AVAILABLE: 'playerEvent.available',
    LOADED_DATA: 'playerEvent.loadeddata',
    LOADED_METADATA: 'playerEvent.loadedmetadata',
    PLAY: 'playerEvent.play',
    PAUSE: 'playerEvent.pause',
    PROGRESS: 'playerEvent.progress',
    TIME_UPDATE: 'playerEvent.timeupdate',
    HIGH_RESOLUTION_TIME_UPDATE: 'playerEvent.highresolutiontimeupdate',
    CAN_PLAY: 'playerEvent.canplay',
    DURATION_CHANGE: 'playerEvent.durationchange',
    SEEKED: 'playerEvent.seeked',
    SEEKING: 'playerEvent.seeking',
    SIZE_CHANGE: 'playerEvent.sizechange',
    VOLUME_CHANGE: 'playerEvent.volumechange',
    SCALE_CHANGE: 'playerEvent.scaleChange',
    ENDED: 'playerEvent.ended',
    FULLSCREEN_CHANGE_REQUESTED: 'playerEvent.fullscreenChangeRequested',
    FULLSCREEN_CHANGE: 'playerEvent.fullscreenChange',
    MEDIA_CHANGE: 'playerEvent.mediaChange'
};

export const PLAYER_CONTROL_EVENT = {
    CURRENT_TIME: 'playerControlEvent.currentTime',
    PLAY: 'playerControlEvent.play',
    PAUSE: 'playerControlEvent.pause',
    VOLUME: 'playerControlEvent.volume',
    MUTE: 'playerControlEvent.mute',
    UNMUTE: 'playerControlEvent.unmute',
    DISABLE_SEEK: 'playerControlEvent.disableSeek',
    ENABLE_SEEK: 'playerControlEvent.enableSeek',
    AUDIO_DESCRIPTIONS_ENABLED: 'playerControlEvent.enableAudioDescriptions',
    AUDIO_DESCRIPTIONS_DISABLED: 'playerControlEvent.disableAudioDescriptions',
    CAPTIONS_ENABLED: 'playerControlEvent.captionsEnabled',
    CAPTIONS_DISABLED: 'playerControlEvent.captionsDisabled'
};

export const ANNOTATION_EVENT = {
    EXECUTABLE_AVAILABLE: 'annotationEvent.executableAvailable',
    ANNOTATIONS_UPDATED: 'annotationEvent.annotations_updated',
    EXPAND_TARGET: 'annotationEvent.expand_target',
    CONTRACT_TARGET: 'annotationEvent.contract_target',
    ANNOTATION_ACTION: 'annotationEvent.annotation_action',
    SHOW: 'annotationEvent.show',
    HIDE: 'annotationEvent.hide',
    TOGGLE: 'annotationEvent.toggle',
    ADD: 'annotationEvent.add',
    REMOVE: 'annotationEvent.remove',
    MODIFY: 'annotationEvent.modify',
    DATA_SENT: 'annotationEvent.dataSent',
    SHOW_CONFIRM: 'annotationEvent.showConfirm',
    ADD_CLASS: 'annotationEvent.addClass',
    REMOVE_CLASS: 'annotationEvent.removeClass',
    SET_CLASS: 'annotationEvent.setClass',
    LANGUAGE_LOAD: 'annotationEvent.languageLoad',
    QUIZ_UPDATED: 'annotationEvent.quizUpdated',
    NEXT_ITEM: 'annotationEvent.nextItem',
    PREV_ITEM: 'annotationEvent.prevItem',
    SUBMIT_FORM: 'annotationEvent.submitForm',
    RESET_FORM: 'annotationEvent.resetForm',
    NAVIGATE_SUB_ELEMENT: 'annotationEvent.navigateSubElement',
    RETRY_QUIZ: 'annotationEvent.retryQuiz',
    RECORD_QUIZ_RESPONSE: 'annotationEvent.recordQuizResponse',
    RECORD_QUIZ_RESPONSE_SUCCEED: 'annotationEvent.quizRecordResponseSucceed',
    QUIZ_RECORD_RESPONSE_FAILED: 'annotationEvent.quizRecordResponseFailed',
    COMPLETE_QUIZ: 'annotationEvent.completeQuiz',
    STATE_CHANGE: 'annotationEvent.stateChange',
    ACTIVATE: 'annotationEvent.activate',
    DEACTIVATE: 'annotationEvent.deactivate',
    LIFECYCLE_CHANGE: 'annotationEvent.lifecycleChange',
    CONDITIONAL_SETTINGS_LOADED: 'annotationEvent.conditionalSettingsLoaded',
    POWER_WORD_DEFINITION_OPENED: 'powerWordDefinitionOpened',
    ENTER_FULLSCREEN: 'annotationEvent.enterFullscreen',
    EXIT_FULLSCREEN: 'annotationEvent.exitFullscreen'
};

export const APPLICATION_EVENT = {
    LOAD: 'applicationEvent.load',
    UPDATED: 'applicationEvent.updated',
    DATA_CHANGE: 'applicationEvent.dataChange',
    AUTH_CHANGE: 'applicationEvent.authchange',
    TRACKING: 'applicationEvent.tracking',
    RENDER: 'applicationEvent.render',
    APPLY_GATE: 'applicationEvent.applyGate',
    RELEASE_GATE: 'applicationEvent.releaseGate',
    STATE_CHANGE: 'applicationEvent.stateChange',
    SET_STATE: 'applicationEvent.setState',
    LOCK_STATE: 'applicationEvent.lockState',
    UNLOCK_STATE: 'applicationEvent.unlockState',
    SEO_INJECTED: 'applicationEvent.seoInjected',
    SOURCE_LOADED: 'applicationEvent.sourceLoaded',
    ERROR: 'applicationEvent.error',
    ANALYTICS_BROADCAST: 'applicationEvent.analyticsBroadcast',
    ANIMATE_CHANGE: 'applicationEvent.animateChange',
    SET_VARIABLES: 'applicationEvent.setVariables',
    FORM_DATA_CHANGE: 'applicationEvent.formDataChange',
    INCREMENT_SCORE: 'applicationEvent.incrementScore',
    DECREMENT_SCORE: 'applicationEvent.decrementScore',
    SET_SCORE: 'applicationEvent.setScore',
    DEPENDENCIES_LOADING: 'applicationEvent.dependenciesLoading',
    LEVEL_CHANGED: 'applicationEvent.levelChanged',
    LEVEL_MENU_OPENED: 'applicationEvent.levelMenuOpened'
};

export const EXTENSION_API = {
    PLAY: 'extensionApi.play',
    PAUSE: 'extensionApi.pause',
    MUTE: 'extensionApi.mute',
    UNMUTE: 'extensionApi.unmute',
    VOLUME: 'extensionApi.volume',
    CURRENT_TIME: 'extensionApi.current_time',
    ADD_CLASSES: 'extensionApi.add_classes',
    REMOVE_CLASSES: 'extensionApi.remove_classes'
};

export const VIEW_PAGE = {
    NAV_BACK_TO_QUIZ_LANDING_PAGE: 'viewPage.navBackToQuizLandingPage',
    PRESENT_MODE_ACTIVE: 'viewPage.presentModeActive',
    QUIZ_RESPONSE_DATA_LOADED: 'viewPage.quizResponseDataLoaded',
    RESET_ACTIVITY_PANEL_CONTENTS: 'viewPage.resetActivityPanelContents',
    VIEW_PAGE_ACTIVITY_PANEL_TOGGLE: 'viewPage.activityPanelToggle'
}